import { flow } from 'lodash/fp'
import { call, put, takeLatest } from 'typed-redux-saga'
import { createAsyncAction } from 'typesafe-actions'
import { IAccount } from '../../../api/account.types'
import { OdataFilterOperatorEnum } from '../../../api/odata'
import {
  createAsyncReducer,
  createAsyncSelectors
} from '../../../store/shared/asyncStore'
import { search } from '../../../store/shared/sagas'
import { getMarginRateAdjustmentFeatureState } from './shared'

export const marginAccountFetchActions = createAsyncAction(
  '@features/@marginRateAdjustment/@moreAccountsFetch/@accounts/REQUEST',
  '@features/@marginRateAdjustment/@moreAccountsFetch/@accounts/SUCCESS',
  '@features/@marginRateAdjustment/@moreAccountsFetch/@accounts/FAILURE'
)<string | undefined, IAccount[] | undefined, Error>()

export const householdAccountsFetchReducer = createAsyncReducer(
  marginAccountFetchActions
)

const rootSelector = flow(
  getMarginRateAdjustmentFeatureState,
  (x) => x?.householdAccountsFetch
)

export const {
  getError: getAccountsError,
  getIsLoading: getIsAccountsLoading,
  getResult: getAccountsResult
} = createAsyncSelectors(rootSelector)

const fetchAccounts = function* (
  action: ReturnType<typeof marginAccountFetchActions.request>
) {
  if (!action.payload) {
    yield put(marginAccountFetchActions.success([]))
    return
  }
  try {
    const result = yield* call(search, 'account' as const, {
      orderBy: [
        { dataPath: 'AccountKPIs/AccountTotal', direction: 'desc' as const }
      ],
      filters: [
        {
          and: [
            {
              operator: OdataFilterOperatorEnum.searchin,
              value: [action.payload],
              path: 'householdId',
              type: 'string' as const
            },
            {
              operator: OdataFilterOperatorEnum.ne,
              value: 'Closed',
              path: 'accountStatus',
              type: 'string' as const
            }
          ]
        }
      ]
    })
    const accounts = result?.value as IAccount[]

    if (!accounts) {
      throw new Error('Accounts for household not found')
    }

    yield put(marginAccountFetchActions.success(accounts as IAccount[]))
  } catch (e: any) {
    yield put(marginAccountFetchActions.failure(e))
  }
}

export const householdAccountsFetchSagas = [
  () => takeLatest(marginAccountFetchActions.request, fetchAccounts)
]
